<template>
  <div
    class="rounded-2xl border transition-all duration-300 bg-white hover:shadow-lg hover:shadow-gray-100/80 border-teal-100 hover:border-teal-200">
    <div class="p-6">
      <div class="flex items-start justify-between gap-4 mb-3">
        <div class="flex items-center gap-2.5">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            :class="['w-4 h-4 flex-shrink-0', isOpen ? 'text-teal-500' : 'text-gray-400']">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="1"></circle>
          </svg>
          <div :class="['inline-flex items-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 border-transparent shadow hover:bg-primary hover:bg-opacity-80 text-xxs-alt leading-normal font-semibold tracking-wide uppercase px-2.5 py-0.5 rounded-full border-0',
            isOpen ? 'bg-teal-50 text-teal-700' : 'bg-gray-100 text-gray-500'
          ]">
            {{ status }}
          </div>
        </div>
      </div>
      <h3 class="text-base font-semibold text-gray-900 leading-snug mb-2">
        {{ item.title }}
      </h3>
      <div class="mb-4">
        <div class="text-sm text-gray-500 leading-relaxed" ref="description" :class="!expanded ? 'line-clamp-2' : ''"
          v-html="item.description"></div>
        <button v-show="showToggle" @click="expanded = !expanded"
          class="inline-flex items-center gap-1 mt-1.5 text-xs font-medium text-teal-600 hover:text-teal-700 transition-colors duration-500">
          <span>{{ expanded ? buttonLessLabel : buttonMoreLabel }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="w-3 h-3 transform" :class="expanded ? 'rotate-180' : ''">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
      </div>
      <div class="space-y-2" v-if="item.files && item.files.length > 0">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
          {{ filesTitle }}
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
          <div class="flex flex-col gap-4" v-for="(file, index) in item.files" :key="`${file.url}-${index}`">
            <a :href="file.url" target="_blank" rel="noopener noreferrer"
              class="group flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:border-teal-200 hover:bg-teal-50/30 transition-all duration-200">
              <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                style="background-color: rgba(25, 165, 175, 0.1)">
                <i class="w-4 h-4 text-geb-green-secondary flex-shrink-0 fill-none" v-icon:doc-alt></i>
              </div>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-700 group-hover:text-teal-700 truncate transition-colors">
                  {{ file.title }}
                </p>
              </div>
              <i class="w-5 h-5 text-gray-300 group-hover:text-teal-500 transition-colors flex-shrink-0 fill-none"
                v-icon:tw-download></i>
            </a>
            <v-summary-tooltip v-if="file.summary" class="text-2xxs md:text-sm" :title="tooltipLabel"
              :content="file.summary">
              {{ tooltipLabel }}
            </v-summary-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    filesTitle: {
      type: String
    },
    cardStatusOpen: {
      type: String
    },
    cardStatusClosed: {
      type: String
    },
    buttonMoreLabel: {
      type: String
    },
    buttonLessLabel: {
      type: String
    },
    tooltipLabel: {
      type: String
    }
  },
  data() {
    return {
      expanded: false,
      showToggle: false
    }
  },
  computed: {
    isOpen() {
      return this.item.status === "open";
    },
    status() {
      return this.isOpen ? this.cardStatusOpen : this.cardStatusClosed;
    },
  },
  mounted() {
    this.observer = new ResizeObserver(() => {
      this.checkOverflow();
    });

    this.observer.observe(this.$refs.description);
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.description;
        if (!el) return;

        const style = window.getComputedStyle(el);
        const lineHeight = parseFloat(style.lineHeight) || (parseFloat(style.fontSize) * 1.2);
        const totalLines = Math.round(el.scrollHeight / lineHeight);

        this.showToggle = totalLines > 2;
      });
    }
  }
};
</script>